import urlJoin from 'url-join';

import {BITMOVIN_API_BASE_PATH} from '../apiConfig';
import HttpService from '../http';

import {AccountInformation} from './entities';

class UserService {
  private constructor() {}

  public static login(username: string, password: string): Promise<AccountInformation> {
    const url = urlJoin(BITMOVIN_API_BASE_PATH, '/account/login');
    return HttpService.post(url, {eMail: username, password}, {}).then(response => response.data.result);
  }

  public static loginWithApiKey(apiKey: string): Promise<AccountInformation> {
    const url = urlJoin(BITMOVIN_API_BASE_PATH, '/account/information');
    return HttpService.authorizedGet(url, apiKey, false, undefined);
  }
}

export default UserService;
